export enum AdminAccessLevel {
  GLOBAL = 'GLOBAL',
  REGION = 'REGION',
  MUNICIPALITY = 'MUNICIPALITY',
}
